import {Model} from '@/models/Model'
import {OrderUser} from '@/models/OrderUser'
import {DataArray} from '@/models/Response'
import {User} from '@/models/User'
import Helper from '../services/Helper.js'


export const SlipConst = Object.freeze({
  STATUS_PENDING: 1,
  STATUS_APPROVED: 5,
  STATUS_PAID: 11,
  STATUS_REJECT: 99,


  map(status: number): string {
    switch (status) {
      case SlipConst.STATUS_PENDING:
        return 'ตะกร้า'
      case SlipConst.STATUS_APPROVED:
        return 'อนุมัติ'
      case SlipConst.STATUS_PAID:
        return 'จ่ายแล้ว'
      case SlipConst.STATUS_REJECT:
        return 'ยกเลิก'
      //รอจัดทริป
      //กำลังขนส่ง
      //
    }
    // debugger
    return ''//'ไม่ระบุ[' + status + ']'
  },


  color(status: number): string {
    switch (parseInt(`${status}`)) {
      case SlipConst.STATUS_PENDING:
        return 'grey lighten-1'
      case SlipConst.STATUS_APPROVED:
        return 'grey lighten-1'
      case SlipConst.STATUS_PAID:
        return 'blue-grey'
      case SlipConst.STATUS_REJECT:
        return 'red'
    }
    // debugger
    return ''
  },

})


export class Slip extends Model {
  declare id: number
  created_at: Date | null
  updated_at: Date | null
  deleted_at: Date | null
  code: string
  status: number | null
  paid_at: Date | null
  user_code: string | null
  receipt_from: Date | null
  receipt_to: Date | null
  total_internal_amount: number | null
  total_external_amount: number | null

  record: OrderUser | null
  records: OrderUser[] | null
  user: User | null

  mode: string | null

  getResourceURL(): string {
    return Helper.setting.slip.getResourceAPI
  }


  async SetStatus(status: number): Promise<Slip> {
    // debugger
    this.status = status
    return await this.save<Slip>()
  }


}

export class DataSlip extends DataArray {

  declare data: Slip

}


export class DataSlipsArray extends DataArray {

  declare data: Slip[]

}

